import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../http.service';
import { v4 as uuidv4 } from 'uuid';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reward-forms',
  templateUrl: './reward-forms.component.html',
  styleUrls: ['./reward-forms.component.scss'],
})
export class RewardFormsComponent implements OnInit {
  instanceId: string = '';
  constructor(
    private apiService: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    // Always generate a new UUID on page load (so it will change even after reload)
    this.instanceId = uuidv4();

    // Optionally, store it in sessionStorage if you want to persist it for the current session
    sessionStorage.setItem('instanceId', this.instanceId);
  }
  getInstanceId() {
    return this.instanceId;
  }
  async ngOnInit() {
    let instanceId = this.getInstanceId();
    //await this.insertLogs('redirection log-' + instanceId);
    this.getRedeemUrl();
  }

  getRedeemUrl() {
    debugger;
    const queryString = window.location.search;
    console.log(queryString);
    console.log(window.location);
    let rewardbaseUrl = environment.rewardUrl;
    let urlfired = rewardbaseUrl + queryString;
    console.log(urlfired);
    const urlParams = new URLSearchParams(queryString);

    //rewards-form/?storeId=7&tripid=99ec5dd7-0489-3cd1-85c0-6ecf3a7c3028-1715771671687074&bName=BOB&siteName=Myntra
    //http://cheg-rewards-form?storeId=7&tripid=uuidcheg&bName=bankid&siteName=Myntra
    const storeId = urlParams.get('storeId');
    const tripid = urlParams.get('tripid');
    const bName = urlParams.get('bName');
    const siteName = urlParams.get('siteName');
    this.apiService
      .getRedeemRedirectUrl(storeId, bName, siteName)
      .then((res) => {
        if (res) {
          let url = res.redirectUrl;

          // Create an instance of the URL object
          let parsedUrl = new URL(url);

          // Extract the query parameter names in the order they appear
          const queryParams: string[] = [];
          parsedUrl.searchParams.forEach((_, key) => {
            queryParams.push(key);
          });
          // Ensure that variables are strings, or assign a default empty string if they are null or undefined
          const newR = tripid ?? '';
          const newAffClickId1 = bName ?? '';
          const newAffClickId2 = siteName ?? '';

          // Replace the query parameters with the new variable data, ensuring the order is maintained
          if (queryParams.length > 0)
            parsedUrl.searchParams.set(queryParams[0], newR); // First parameter
          if (queryParams.length > 1)
            parsedUrl.searchParams.set(queryParams[1], newAffClickId1); // Second parameter
          if (queryParams.length > 2)
            parsedUrl.searchParams.set(queryParams[2], newAffClickId2); // Third parameter

          // Get the updated URL as a string
          const updatedUrl = parsedUrl.toString();

          // Redirect to the updated URL
          // window.location.href = updatedUrl;
          debugger;
          let sessionId;
          const data = {
            AdvertiserName: siteName,

            StoreId: storeId,
            CategoryName: '',
            ProductName: '',
            ProductURL: urlfired,
            Price: 0,
            ASINNumber: '',
            SearchedKeyword: '',
            BankName: bName,
            DeviceType: '',
            DeviceBrowser: '',
            OfferID: 0,
            OfferName: '',
            TripID: tripid,
            SessionID: '',
            PreLoginId: '',
            ChegCustomerId: tripid?.split('-').pop(),
            PageName: 'rewards',
          };
          const model = {
            ...data,
            sessionId,
          };

          this.apiService.postProductInfo(model).then((res) => {
            window.location.href = updatedUrl;
          });
        }
      });
  }
  async insertLogs(url: any) {
    let data = {
      moduleName: 'Swinkpay url fired',
      url: url,
    };
    let result = this.apiService.insertLogs(data);
  }
}
